import { TextField, Button, Modal } from "@material-ui/core";
import React, { useState, useRef, useEffect } from "react";
import ManWork from "../../../ebusHomePics/man-work.png";
import flutter from "../../../ebusHomePics/Flutter.png";
import CES from "../../../ebusHomePics/CES.png";
import FrontBack from "../../../ebusHomePics/Front-Back.png";
import Graphic from "../../../ebusHomePics/Graphic.png";
import Mail from "../../../ebusHomePics/Mali.png";
import SEO from "../../../ebusHomePics/SEO.png";
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import * as Scroll from "react-scroll";
import "./jobsOpp.css";
import { Formik, Form, Field } from "formik"
import * as Yup from "yup"
import { sendRezomeInfo } from "./EmployCrud"
import { ToastContainer, toast } from "react-toastify"
import Succes from "./assest/Succes.svg"

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const yupValidationSchema = Yup.object().shape({
  firstname: Yup.string()
    .required("این فیلد نمیتواند خالی باشد"),
  lastname: Yup.string()
    .required("این فیلد نمیتواند خالی باشد"),
  phone: Yup.string()
    .min(11, "شماره موبایل را به درستی وارد کنید")
    .max(11, "شماره موبایل را به درستی وارد کنید")
    .required("این فیلد نمیتواند خالی باشد")
    .typeError("فرمت وارد شده صحیح نمی باشد"),
  job: Yup.string()
    .required("لطفا یک مورد را انتخاب کنید"),
  rezomePath: Yup.mixed()
  // .required("فایل رزومه را انتخاب کنید"),
  // .test("fileSize", "File too large", value => { return value.size <= 1000000 }) // 1MB max
  // .test('fileFormat', 'PDF only', (value) => {
  //   return value && ['application/pdf'].includes(value.type);}),
})
const openInNewTab = url => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop) 

const JobsOpp = (props) => {

  let scroll = Scroll.animateScroll;

  const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
  });

  const classes = useStyles();
  const [state, setState] = React.useState({
    firstname: "",
    lastname: "",
    phone: "",
    job: "",
    description: "",
    rezomePath: "",
  });

  const [file, setFile] = useState();
  const [fileName, setFileName] = useState('');
  const [modalOpen, setModalOpen] = useState(false)
  const [submitOpen, setSubmitOpen] = useState(false)

  const handleChange = (event) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  const initial = {
    firstname: "",
    lastname: "",
    phone: "",
    job: "",
    description: "",
    rezomePath: "",
  }
  const initial_file = {
    file: null
  }

  const initial_fileName = {
    fileName: ""
  }


  const saveFile = (e) => {
    setFile(e.target.files[0]);
    setFileName(e.target.files[0].name);
  };

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);

  const handleModalClose = () => {
    console.log("closing")
    setModalOpen(false)
  }

  const myRef = useRef(null)
   const executeScroll = () => scrollToRef(myRef)

  const sendRezome = () => {
    const formData = new FormData();
    formData.append("firstname", state.firstname);
    formData.append("lastname", state.lastname);
    formData.append("phone", state.phone);
    formData.append("job", state.job);
    formData.append("description", state.description);
    formData.append("file", file);
    formData.append("fileName", fileName);
    setSubmitOpen(true)
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
    sendRezomeInfo(formData)
      .then(res => {
        console.log("info", res.data);
        setState(initial)
        setFile(initial_file)
        setFileName(initial_fileName)
      })
      .catch(err => {
        err.status === 410 && toast.error("لطفا فایل رزومه خود را ارسال کنید")
        console.log(err)
      });
  }

  return (<>
    {submitOpen ? 
      <div className="container d-flex justify-content-center align-items-center mt-30">
        <div className="d-flex justify-content-center align-items-center mt-15 p-5 row bg-white px-10"  ref={myRef} style={{boxShadow: "rgb(0 0 0 / 10%) 0px 0px 10px 0px"}}>
          <img src={Succes} style={{width:"100px"}}></img>
          <div className="col-12 d-flex justify-content-center mt-5" style={{fontWeight:"bold",fontSize:"35px"}}><p className="mb-0">رزومه با موفقیت ثبت شد.</p></div>
          <div className="col-12 d-flex justify-content-center">
            <p>بزودی رزومه شما بررسی و در صورت نیاز با شما تماس گرفته خواهد شد. </p>
            <div>با سپاس</div>
          </div>
          <div className="col-12 d-flex justify-content-center mt-8">
            <Button
                className="col-3 my-2 p-5 "
                style={{ backgroundColor:  "#3DC36D", borderRadius: "15px", fontSize: "large" }}
              >
                <a href="http://ebus.ir/jobs-opportunities"> <span className="mx-auto my-auto text-white">بازگشت به فرصت های شغلی</span></a>
            </Button>
          </div>
        </div>
      </div>
     :
    <div className="row">
      <ToastContainer
        position="top-right"
        autoClose={5000}
        closeOnClick
        rtl={true}
        pauseOnHover
      />
      <div className="w-100 p-0 mt-6 pt-5" id="jobTitle">
        <div className="container w-100 h-100 d-flex justify-content-center">
          <h1 className="align-self-start mb-0">
            <b>فرصت های شغلی ایباس </b>
          </h1>
        </div>
      </div>
      <div className="container h-auto " style={{ marginBlock: "3rem" }}>
        <div
          className="container py-5 bg-white landings-container">
          <div className="d-block d-md-flex flex-wrap">
            <div className="col-12 col-md-6">
              {" "}
              <h5 className="mt-20" style={{ lineHeight: "30px" }}>

                <p className="d-inline-block mb-0" style={{ fontWeight: "bold" }}>"ایباس"</p>
                <br />
                اولین تیمِ استارتاپی در حوزه
                "حمل و نقل بین شهری اتوبوسی "
                که برای ارائه راه حل های توسعه حمل و نقل، شونه به شونه برای اهداف مشترک کنارهم تلاش می کنیم و در این راه حامی هم هستیم.<br /> برای رشد و توسعه به مهارت ها و توانایی های شما احتیاح داریم.
                <br />
                <p className="d-inline-block mb-0" style={{ fontWeight: "bold" }}>هم مسیر ایباس باشید اگر :</p>
                <br />
                روحیه ی کارتیمی رو در خودتون می بینید.
                <br />
                تجربه کار در یک محیط انعطاف پذیر و پویا رو می پسندید.
                <br />
                به دنبال پیشرفت و یادگیری هستید،
                دغدغه برنامه ریزی برای رسیدگی به کارهارو دارید.
                <br /><br />
                برای ایجاد یک تغییر هم راه ما باشید
                .

              </h5>
            </div>
            <div
              style={{ height: "30rem" }}
              className="col-12 col-md-6 d-md-flex justify-content-center"
            >
              <img className="h-80 h-md-100" src={ManWork} style={{ maxWidth: "100%" }} />
            </div>
          </div>
        </div>

        <div className="container pt-9 bg-white landings-container mt-7">
          <h3
            className="text-dark d-flex justify-content-center"
            style={{ fontWeight: "bold" }}
          >
            فهرست مشاغل موجود
          </h3>
          <div className="row mt-15 mb-10 ">
            <div className="col-md-7 col-12" id="CES">
              <span className="row p-0 m-0">
                <img className="d-inline-block p-2 p-lg-3" src={CES} alt="" />
                <h6 className="d-inline-block px-md-3 p-0 col-10" style={{ cursor: "pointer", lineHeight: "49px" }} onClick={() => openInNewTab("http://ebus.ir/service/rezome/requirementFiles/CES.pdf")}>Customer Experience Specialist</h6>
              </span>
            </div>
            <div className="col-md-5 col-12">
              <img className="d-inline-block p-2 p-lg-3 " src={flutter} alt="" />
              <h6 className="d-inline-block p-3" style={{ cursor: "pointer" }} onClick={() => openInNewTab("http://ebus.ir/service/rezome/requirementFiles/Flutter.pdf")} > Flutter Developer</h6>
            </div>
            <div className="col-md-7 col-12">
              <img className="d-inline-block p-2 p-lg-3" src={SEO} alt="" />
              <h6 className="d-inline-block p-3" style={{ cursor: 'pointer' }} onClick={() => openInNewTab("http://ebus.ir/service/rezome/requirementFiles/SeoSpecialist.pdf")}>SEO Specialist</h6>
            </div>
            <div className="col-md-5 col-12">
              <img className="d-inline-block p-2 p-lg-3" src={Graphic} alt="" />
              <h6 className="d-inline-block p-3 " style={{ cursor: "pointer" }} onClick={() => openInNewTab("http://ebus.ir/service/rezome/requirementFiles/graphic.pdf")}>Graphic Designer</h6>
            </div>
            <div className="col-md-7 col-12">
              <img className="d-inline-block p-2 p-lg-3 " src={FrontBack} alt="" />
              <h6 className="d-inline-block p-md-3 p-0 col-10 " style={{ cursor: 'pointer' }} onClick={() => openInNewTab("http://ebus.ir/service/rezome/requirementFiles/FrontEnd.pdf")}> FrontEnd Developer | ReactJs</h6>
            </div>
            <div className="col-md-5 col-12">
              <img className="d-inline-block p-2 p-lg-3" src={Mail} alt="" />
              <h6 className="d-inline-block p-3" style={{ cursor: "pointer" }} onClick={() => openInNewTab("http://ebus.ir/service/rezome/requirementFiles/mali.pdf")}>Finance Officer</h6>
            </div>
            <div className="col-md-7 col-12">
              <img className="d-inline-block p-2 p-lg-3" src={FrontBack} alt="" />
              <h6 className="d-inline-block p-md-3 p-0 col-10" style={{ cursor: "pointer" }} onClick={() => openInNewTab("http://ebus.ir/service/rezome/requirementFiles/backend.pdf")}> BackEnd Developer | NodeJs</h6>
            </div>
          </div>
        </div>

        <div className="container pt-9 bg-white landings-container mt-7 sending-resume">
          <h3
            style={{ fontWeight: "bold" }}
            className="d-flex justify-content-center"
          >
            ارسال رزومه
          </h3>
          <h4
            className="my-5 text-dark d-flex justify-content-center"
            style={{ lineHeight: "30px" }}>
            پیشینه تحصیلی، مهارتی و شغلی خودتون رو برای ما ارسال کنید.
          </h4>
          
          <Formik
            enableReinitialize
            validateOnBlur={true}
            initialValues={state}
            validationSchema={yupValidationSchema}
            onSubmit={(values) => {
              console.log(values);
              sendRezome();
            }}
          >
            {({
              handleSubmit,
              errors,
              touched,
              isSubmitting,
              initialValues,
              setFieldValue,
              values,
            }) => (
              <Form className="form form-label-right">
              <div className="form-group row">
                <div className="d-flex flex-wrap justify-content-center container">
                  <div className="col-6 col-md-3 p-2 my-2">
                    <TextField
                      name="firstname"
                      className="w-100"
                      id="outlined-basic"
                      label="نام"
                      variant="outlined"
                      value={state.firstname}
                      onChange={(e) => handleChange(e)}
                    />
                    {touched.firstname ? (
                      <b className="text-danger">
                        {errors.firstname}
                      </b>
                    ) : null}
                  </div>
                  <div className="col-6 col-md-3 p-2 my-2">
                    {" "}
                    <TextField
                      name="lastname"
                      className="w-100 lastname"
                      id="outlined-basic"
                      label="نام خانوادگی"
                      variant="outlined"
                      value={state.lastname}
                      onChange={(e) => handleChange(e)}
                    />
                    {touched.lastname ? (
                      <b className="text-danger">
                        {errors.lastname}
                      </b>
                    ) : null}
                  </div>
                  <div className="col-12 col-md-3 p-2 my-2">
                    {" "}
                    <TextField
                      name="phone"
                      className="w-100"
                      id="outlined-basic"
                      label="موبایل"
                      variant="outlined"
                      value={state.phone}
                      onChange={(e) => handleChange(e)}
                    />
                    {touched.phone ? (
                      <b className="text-danger">
                        {errors.phone}
                      </b>
                    ) : null}
                  </div>
                  <div className="col-12 col-md-3 p-2 my-2 jobPadding">
                    {" "}
                    <CacheProvider value={cacheRtl}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel htmlFor="outlined-job-native-simple">عنوان شغلی</InputLabel>
                        <Select
                          style={{ borderRadius: "13px", cursor: 'pointer' }}
                          native
                          value={state.job}
                          onChange={(e) => handleChange(e)}
                          label="عنواااان شغلی"
                          inputProps={{
                            name: 'job',
                            id: 'outlined-job-native-simple',
                          }}
                        >
                          <option aria-label="None" value="" />
                          <option value={1} style={{ cursor: 'pointer' }}>BackEnd Developer | NodeJs</option>
                          <option value={2} style={{ cursor: 'pointer' }}>FrontEnd Developer | ReactJs</option>
                          <option value={3} style={{ cursor: 'pointer' }}>Customer Experience Specialist</option>
                          <option value={4} style={{ cursor: 'pointer' }}>SEO Specialist</option>
                          <option value={5} style={{ cursor: 'pointer' }}>Graphic Designer</option>
                          <option value={6} style={{ cursor: 'pointer' }}>Financial Expert</option>
                          <option value={7} style={{ cursor: 'pointer' }}>Flutter Developer</option>
                        </Select>
                        {touched.job ? (
                          <b className="text-danger">
                            {errors.job}
                          </b>
                        ) : null}
                      </FormControl>
                    </CacheProvider>
                  </div>
                  <div className="col-12 p-2 my-2">
                    {" "}
                    <TextField
                      name="description"
                      className="w-100 h-100 Description"
                      id="outlined-basic"
                      label="توضیحات"
                      variant="outlined"
                      value={state.description}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                  <div className="col-12 p-2 mb-10 d-block d-md-flex justify-content-between">
                    <div className="col-12 col-md-2 pt-2 px-0">
                      <input
                        name="rezomePath"
                        accept="application/pdf"
                        type="file"
                        onChange={saveFile} />
                      <div>
                        <b className="text-blank">
                          فایل به فرمت pdf وارد کنید
                        </b>
                      </div>
                      {touched.rezomePath ? (
                        <b className="text-danger mt-1">
                          {errors.rezomePath}
                        </b>
                      ) : null}
                    </div>
                    <div
                      className="col-12 col-md-2 my-2 p-0 "
                      style={{ height: "4rem" }}
                    >
                      <Button
                        className="w-100 h-100 mt-5 mt-md-0"
                        style={{ backgroundColor: `${file ? "#39b54a" : "#c4e0ca"}`, borderRadius: "13px", fontSize: "large" }}
                        disabled={file ? false : true}
                        onClick={() => {handleSubmit()}}
                      >
                        <span className="mx-auto my-auto text-white">ثبت</span>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              </Form>
            )}
          </Formik>
          
        </div>
      </div>
    </div>
    }
    </>
  );
};

export default JobsOpp;
